import { AWSIcon, Logo, LogoSiamAi } from '@/components/ui/icons';
import {
  ProviderInstance,
  ProviderInstanceLabel,
} from '@/service/one-click-deploy/type';
import { SVGProps } from 'react';


export const mapOptionProvider = {
  [ProviderInstance.AWS]: {
    label: ProviderInstanceLabel[ProviderInstance.AWS],
    icon: AWSIcon,
    iconDark: (props: SVGProps<SVGSVGElement>) => <AWSIcon fillText="#ffffff" {...props} />,
  },
  [ProviderInstance.Float16]: {
    label: ProviderInstanceLabel[ProviderInstance.Float16],
    icon: Logo,
    iconDark: Logo,
  },
  [ProviderInstance.SiamAICloud]: {
    label: ProviderInstanceLabel[ProviderInstance.SiamAICloud],
    icon: LogoSiamAi,
    iconDark: LogoSiamAi,
  },
};
